import React from 'react';

const LoadingSpinner = ({ text = 'Loading...', size = 'medium' }) => {
  const sizeClasses = {
    small: { width: '1rem', height: '1rem' },
    medium: { width: '2rem', height: '2rem' },
    large: { width: '3rem', height: '3rem' }
  };

  const spinnerStyle = {
    ...sizeClasses[size],
    border: '2px solid #f3f3f3',
    borderTop: '2px solid #007bff',
    borderRadius: '50%',
    animation: 'spin 1s linear infinite'
  };

  return (
    <div className="loading">
      <div style={spinnerStyle}></div>
      {text && <span className="loading-text">{text}</span>}
    </div>
  );
};

export default LoadingSpinner;
